export const isOfflineBridgeError = (
  error: unknown,
  errorCode: string,
  displayText: string
): boolean => {
  if (typeof error === 'string') return error.includes(displayText);
  if (typeof error !== 'object' || error === null) return false;
  const { message, error_code: code } = error as {
    message?: unknown;
    error_code?: unknown;
  };
  return (
    code === errorCode || (typeof message === 'string' && message.includes(displayText))
  );
};
